import { gql } from '@apollo/client';

export const MEMBER_ELIGIBILITY_CHECK_BY_BIG_N = gql`
  query memberEligibilityCheckForBigNForStandalone(
    $input: MemberBigNInput
    $serviceSector: String
    $email: String
    $marketingConsent: Boolean
  ) {
    memberEligibilityCheckForBigNForStandalone(
      bigN: $input
      serviceSector: $serviceSector
      email: $email
      marketingConsent: $marketingConsent
    ) {
      status
      registrationUrl
      serviceSector
      memberCode
    }
  }
`;
